// 後端業務端點的呼叫層。/public/* 不帶 token；/staff/* 帶 Cognito ID token。
// 不要在這裡 console.log 請求或回應內容（含個資）。
import { fetchAuthSession } from "aws-amplify/auth";
import { config } from "./config";

export class ApiError extends Error {
  constructor(status, code, message, extra = {}) {
    super(message || code);
    this.status = status;
    this.code = code;
    this.extra = extra;
  }
}

const idToken = async () => {
  const session = await fetchAuthSession();
  const token = session?.tokens?.idToken?.toString();
  if (!token) {
    throw new ApiError(401, "unauthenticated", "請重新登入");
  }
  return token;
};

export const apiRequest = async (method, path, { query, body, auth = false } = {}) => {
  if (!config.apiBaseUrl) {
    throw new ApiError(0, "notConfigured", "apiBaseUrl 未配置");
  }
  const url = new URL(path, config.apiBaseUrl);
  Object.entries(query || {}).forEach(([k, v]) => {
    if (v !== undefined && v !== null) url.searchParams.set(k, v);
  });
  const headers = { Accept: "application/json" };
  if (body !== undefined) headers["Content-Type"] = "application/json";
  if (auth) headers.Authorization = `Bearer ${await idToken()}`;

  let response;
  try {
    response = await fetch(url, {
      method,
      headers,
      body: body === undefined ? undefined : JSON.stringify(body),
    });
  } catch (err) {
    throw new ApiError(0, "network", err.message);
  }
  let data = null;
  try {
    data = await response.json();
  } catch (_e) {}
  if (!response.ok || !data?.ok) {
    const { code, message, ok, ...extra } = data || {};
    throw new ApiError(response.status, code || "httpError", message, extra);
  }
  return data;
};

// 後端錯誤代碼 → 給使用者看的訊息
const ERROR_MESSAGES = {
  full: "此時段已額滿，請選擇其他時段",
  repeatSameDay: "請勿重複預約同一天",
  noShowBlocked:
    "因有未報到紀錄，無法線上掛號。請就診當日來電確認現場號是否開放。",
  isFollow: "您為複診身份, 切換到複診挂號頁面",
  notFollow: "找不到複診資料, 切換到初診挂號頁面",
  birthdayMismatch:
    "資料不正確，請確認生日日期是否正確,應如20210821, 或是致電診所確認",
  badVerification: "驗證碼錯誤，請重新輸入",
  invalidName:
    "請填寫正確的姓名格式, 如: 王小明, 李大衛, 張三, 至少包含兩個中文字符或英文字符且前後不能有空白",
  invalidPhone: "請填寫正確的手機號碼，如0988123456",
  invalidBirthday: "請填寫正確的生日格式，如:20210701",
  invalidId:
    "請填寫正確的證件號碼格式，至少9碼，只能包含英文和數字，且前後不能有空白",
  invalidGender: "請選擇性別",
  closed: "此時段未開放預約，請選擇其他時段",
  specialClinic: "此時段為特約門診，請透過注意事項中的連結預約",
  onlineClosed: "開診前兩小時已關閉網路預約，請至現場掛號",
  pastDate: "此日期無法預約",
  outOfWindow: "此日期尚未開放預約",
  onsiteNotToday: "現場號只能掛當日",
  tooManyAttempts: "嘗試次數過多，請一小時後再試或致電診所",
  sameDayCancel: "當日無法取消，請於就診前一天前取消",
  notFound: "找不到這筆預約，請重新查詢",
  clinicForbidden: "此帳號無權限操作這間診所",
  forbidden: "此帳號無權限進行這個操作",
  unauthenticated: "請重新登入",
  concurrentUpdate: "資料剛被其他人修改，請重新整理後再試",
  invalidTitle: "標題不可空白，且不能超過 50 字",
  invalidItems: "至少要有一個項目，且不能超過 30 個",
  itemTooLong: "每個項目不能超過 1000 字",
  unsafeLink: "連結網址必須以 http:// 或 https:// 開頭",
};

export const errorMessage = (err) => {
  if (err?.code === "repeat" && err.extra?.dateSlot) {
    return `您已經在${err.extra.dateSlot} ${err.extra.timeSlot}預約過了,請勿重複預約`;
  }
  return ERROR_MESSAGES[err?.code] || "系統忙碌中，請稍後再試或致電診所";
};
